/** Israeli mobile number helpers — normalisation, validation and display. */

/** Digits only, `+972`/`972` prefixes folded back to the local `05…` form. */
export function normalizePhone(raw: string): string {
  const digits = (raw ?? '').replace(/\D+/g, '');
  if (digits.startsWith('972')) return `0${digits.slice(3)}`;
  return digits;
}

/** A valid Israeli mobile: `05` followed by 8 digits. */
export function isValidMobile(raw: string): boolean {
  return /^05\d{8}$/.test(normalizePhone(raw));
}

/** `0500000001` → `050-000-0001`. Invalid input is returned untouched. */
export function formatPhone(raw: string): string {
  const phone = normalizePhone(raw);
  if (!/^05\d{8}$/.test(phone)) return raw ?? '';
  return `${phone.slice(0, 3)}-${phone.slice(3, 6)}-${phone.slice(6)}`;
}

/** Masked form for confirmation screens: `050-***-0001`. */
export function maskPhone(raw: string): string {
  const phone = normalizePhone(raw);
  if (!/^05\d{8}$/.test(phone)) return raw ?? '';
  return `${phone.slice(0, 3)}-***-${phone.slice(6)}`;
}
